// extracted by mini-css-extract-plugin
export default {"container":"rules_container__pQRx4","rules":"rules_rules__7Ip+d","green":"rules_green__GMqyW","yellow":"rules_yellow__ctNMZ","grey":"rules_grey__LMWTP"};